import { mapServerToProductBase } from "./map-server-to-product-base.js";
import { mapServerToContactLensVariant } from "../../../../variant-mappers/mappers/server-to-client/variant-mappers/map-server-to-contact-lens-variant.js";
const mapServerToContactLensProduct = (serverProduct, slug, locale, facetConfigList, flatFacetConfigList, priceSegmentChannelKey) => {
  if (serverProduct?.__typename !== "ContactLensProduct") {
    return {
      failure: "incorrect-typename",
      message: `Expected ContactLensProduct for slug "${slug}", but got ${serverProduct?.__typename}`
    };
  }
  const variants = mapServerToContactLensVariant(
    serverProduct,
    slug,
    locale,
    priceSegmentChannelKey
  );
  if (!variants || variants.length === 0) {
    return {
      failure: "no-variants",
      message: `Cannot return Contact Lens product with slug: "${slug}" because it has no variants`
    };
  }
  const { masterSku: defaultMasterSku, ...productbase } = mapServerToProductBase(
    serverProduct,
    variants,
    facetConfigList,
    flatFacetConfigList
  );
  const masterSku = variants.find((variant) => variant.isMasterProduct)?.sku || defaultMasterSku;
  return {
    ...productbase,
    productType: "Contact-lenses",
    variants,
    masterSku,
    isMasterProduct: serverProduct.productTypeDetails.isMaster,
    productMasterKey: serverProduct.productTypeDetails.productMasterKey
  };
};
export {
  mapServerToContactLensProduct
};
//# sourceMappingURL=map-server-to-contact-lens-product.js.map
